<template>
  <v-container class="d-flex justify-center">
    <UploadDocumentTable />
  </v-container>
</template>

<script>
import UploadDocumentTable from './components/uploadDocumentTable/UploadDocumentTable.vue'

export default {
  components: {
    UploadDocumentTable,
  },

  data: () => ({}),

  methods: {},

  created() {},
}
</script>
